var generateStyle = function generateStyle(componentTheme) {
  return {
    choiceWrapperAdjustment: {
      /* hack to align FormFieldGroup bottom padding with
      dropdown label padding when side by side */
      marginTop: '-0.3rem'
    }
  };
};
export default generateStyle;